import { render, staticRenderFns } from "./BigMapPartition.vue?vue&type=template&id=179feab4&scoped=true"
import script from "./BigMapPartition.vue?vue&type=script&lang=js"
export * from "./BigMapPartition.vue?vue&type=script&lang=js"
import style0 from "./BigMapPartition.vue?vue&type=style&index=0&id=179feab4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179feab4",
  null
  
)

export default component.exports